import type { Color } from "@design-lab/shared/types/base";
import { cn } from "@design-lab/shared/lib/tailwindcss";

type SelectedColorDisplayProps = {
  selectedColor: Color;
  className?: string;
};

export function SelectedColorDisplay(props: SelectedColorDisplayProps) {
  const { selectedColor, className } = props;

  return (
    <div className={cn("font-inter mb-2 flex items-center gap-2", className)}>
      <span className="text-sm font-medium text-gray-500">Selected Color:</span>
      <span className="text-sm font-semibold text-gray-900">{selectedColor.name}</span>
      <div
        className="size-6 shrink-0 overflow-hidden rounded-full border border-gray-300"
        style={{ backgroundColor: selectedColor.hex }}
      >
        {selectedColor.swatchUrl && (
          <img
            src={selectedColor.swatchUrl}
            alt={selectedColor.name}
            className="size-full object-cover"
          />
        )}
      </div>
    </div>
  );
}
